import { Palette } from '@ardoq/api-types';

export const qualitativeTheme: Palette = {
  // used for pie chart and stacked bar chart widgets
  label: 'Qualitative theme',
  paletteColors: [
    '#A002F1',
    '#FDD000',
    '#00C4E5',
    '#AC6F00',
    '#0C6BC5',
    '#E0DCDF',
    '#FB6C80',
    '#57CD9C',
    '#670501',
    '#98DA1D',
    '#7F2D93',
    '#C173CF',
    '#598322',
    '#EA2DB9',
    '#0B4512',
    '#B0989E',
  ],
};

export const conditionalFormattingTheme: Palette = {
  // used for number widgets
  label: 'Conditional formatting',
  paletteColors: ['#FF002F', '#FFA100', '#00B200'],
};
